import { useTranslation } from "react-i18next";
import type { ReactNode } from "react";
import { ResizableSidebar } from "@/components/ResizableSidebar";
import { HorizontalTabs } from "@/components/HorizontalTabs";

export interface SidebarTab {
  value: string;
  label: string;
  content: ReactNode;
}

interface Props {
  tabs: SidebarTab[];
  defaultWidth?: number;
  minWidth?: number;
  maxWidth?: number;
}

/** Standard ResizableSidebar + HorizontalTabs wrapper used on all request detail pages. */
export const RequestDetailSidebar = ({
  tabs,
  defaultWidth = 440,
  minWidth = 360,
  maxWidth = 560,
}: Props) => {
  const { t } = useTranslation(["common"]);
  return (
    <ResizableSidebar
      title={t("common:spaces.company")}
      defaultWidth={defaultWidth}
      minWidth={minWidth}
      maxWidth={maxWidth}
    >
      {/* Tab `label`s may be either display text or an `ns:key` lookup —
          the tab factories cannot call a hook, so they hand us a key and we
          resolve it here, the one place every request-detail tab passes through.
          `defaultValue` keeps already-translated labels working unchanged. */}
      <HorizontalTabs
        tabConfig={tabs.map((tab) => ({
          ...tab,
          label: t(tab.label, { defaultValue: tab.label }),
        }))}
        styles={{
          tabs: "h-full flex flex-col",
          tabsTrigger: "flex-1 justify-center",
          tabsContent: "p-0 flex-1 overflow-auto",
        }}
      />
    </ResizableSidebar>
  );
};
